
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/space/[...slug]",
      function () {
        return require("private-next-pages/space/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/space/[...slug]"])
      });
    }
  